import {
  GetDataMachine, GetDataCompany, GetDataAgent, GetDataSite, GetDataStatistics,
  GetSettle, GetSettleDetail, GetSettleAndDetail, GetSettleReturnJob, GetConvert, SaveConvert, GetMeterLogDevices, GetMeterSettlement, GetPrintStatistics, GetScanStatistics
} from '@/api/data'
export default {
  state: {

  },
  actions: {
    GetDataMachine({ commit }, payload) {
      return new Promise(resolve => {
        GetDataMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDataCompany({ commit }, payload) {
      return new Promise(resolve => {
        GetDataCompany(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDataAgent({ commit }, payload) {
      return new Promise(resolve => {
        GetDataAgent(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDataSite({ commit }, payload) {
      return new Promise(resolve => {
        GetDataSite(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDataStatistics({ commit }, payload) {
      return new Promise(resolve => {
        GetDataStatistics(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetSettle({ commit }, payload) {
      return new Promise(resolve => {
        GetSettle(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetSettleDetail({ commit }, payload) {
      return new Promise(resolve => {
        GetSettleDetail(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetSettleAndDetail({ commit }, payload) {
      return new Promise(resolve => {
        GetSettleAndDetail(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetSettleReturnJob({ commit }, payload) {
      return new Promise(resolve => {
        GetSettleReturnJob(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveConvert({ commit }, payload) {
      return new Promise(resolve => {
        SaveConvert(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetConvert({ commit }, payload) {
      return new Promise(resolve => {
        GetConvert(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterLogDevices({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterLogDevices(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterSettlement({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterSettlement(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetPrintStatistics({ commit }, payload) {
      return new Promise(resolve => {
        GetPrintStatistics(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetScanStatistics({ commit }, payload) {
      return new Promise(resolve => {
        GetScanStatistics(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
